var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 383.19 378.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M383.19,348.1c-1.85,4.85-3,10.15-5.67,14.47-8.51,13.63-21.61,17.5-36.89,15.86-9.48-1-17.12-5.46-23.78-12.14Q255.8,305.08,194.63,244a43,43,0,0,1-3-3.81c-1.59,1.52-2.66,2.5-3.69,3.52L63.79,367.8c-12.36,12.36-33.88,14.73-48.73,5.41-16.88-10.6-20.19-36-6.76-52,1.28-1.52,2.68-3,4.09-4.36q62.19-62.21,124.4-124.37a27.26,27.26,0,0,1,3.56-2.52c-1.61-1.72-2.49-2.72-3.43-3.66Q74.75,124.12,12.55,61.93A36.2,36.2,0,0,1,58.82,6.58a41.49,41.49,0,0,1,5.36,4.64q61.6,61.2,123.15,122.43c1.24,1.23,2.38,2.55,3.9,4.18,1.27-1.21,2.34-2.17,3.35-3.18Q255.84,73.39,317.12,12.13C337.26-8,370.29-.2,378.14,26.59c3.95,13.47,1.11,25.71-9,35.82Q307.81,123.85,246.38,185.2c-1.06,1.06-2.23,2-3.67,3.27,1.29,1.35,2.25,2.42,3.27,3.43q61,60.69,122.16,121.3c7.3,7.21,12.94,15,15.05,25.17Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.591eeb27c472ed3080ef827bd9424b4f.svg";
export { ForwardRef as ReactComponent };